import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../context/SocketContext';
import ChatBox from '../components/ChatBox';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(req => {
  const token = localStorage.getItem('token');
  if (token) req.headers.Authorization = 'Bearer ' + token;
  return req;
});

const FLAGS = { JP:'🇯🇵',ES:'🇪🇸',FR:'🇫🇷',CN:'🇨🇳',US:'🇺🇸',KR:'🇰🇷',IT:'🇮🇹',RU:'🇷🇺' };

export default function FriendsPage() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState('friends');
  const [friends, setFriends] = useState([]);
  const [requests, setRequests] = useState([]);
  const [nearby, setNearby] = useState([]);
  const [msg, setMsg] = useState('');
  const { socket } = useSocket();
  const [partner, setPartner] = useState(null);
  const [showChat, setShowChat] = useState(false);
  const [sess, setSess] = useState({ id: null });
  const [loading, setLoading] = useState({});
  const [incomingMsg, setIncomingMsg] = useState(null);
  const [unread, setUnread] = useState({});
  useEffect(() => {
    if (!socket) return;
    var handler = function(msgData) {
      var msg = msgData.message;
      if (msg.sender_id === sess?.user_id_1 || msg.sender_id === sess?.user_id_2) return;
      var sender = friends.find(function(u) { return u.user_id === msg.sender_id; });
      if (sender) { setIncomingMsg({ user:sender, text:msg.original_text }); setUnread(function(p){var n=Object.assign({},p);n[msg.sender_id]=(n[msg.sender_id]||0)+1;return n;}); }
      setTimeout(function(){ setIncomingMsg(null); }, 6000);
    };
    socket.on('new_message', handler);
    return function() { socket.off('new_message', handler); };
  }, [socket, friends, sess]);
  
  var handleIncoming = function(incoming) {
    setIncomingMsg(null);
    setPartner(incoming.user);
    setShowChat(true);
    setUnread(function(p){var n=Object.assign({},p);delete n[incoming.user.user_id];return n;});
    // Fetch existing session immediately
    axios.get('/api/sessions/get?targetUserId=' + incoming.user.user_id).then(function(r){if(r.data && r.data.id){setSess(r.data);}}).catch(function(){});
    // Also try via socket for real-time
    if (socket) {
      socket.emit('create_session', { targetUserId: incoming.user.user_id });
      var onS = function(s) { setSess(s); socket.off('session_created', onS); };
      socket.on('session_created', onS);
    }
  };

  useEffect(() => {
    api.get('/friends').then(r => setFriends(r.data)).catch(() => {});
    api.get('/friends/requests').then(r => setRequests(r.data)).catch(() => {});
    api.get('/friends/nearby').then(r => setNearby(r.data)).catch(() => {});
  }, []);

  const sendRequest = async (toUserId) => {
    try { await api.post('/friends/request', { toUserId }); setMsg('✅ 好友请求已发送'); } catch(e) { setMsg('❌ ' + (e.response?.data?.error || '失败')); }
    setTimeout(() => setMsg(''), 3000);
  };

  const removeFriend = async (friendId) => { try { await api.post('/friends/remove', {friendId}); const rr = await api.get('/friends'); setFriends(rr.data); setMsg('已删除'); setTimeout(function(){setMsg('')},2000); } catch(e) { setMsg('删除失败'); } };
  const handleChat = function(u){
    setPartner(u);
    setShowChat(true);
    setUnread(function(p){var n=Object.assign({},p);delete n[u.user_id];return n;});
    axios.get('/api/sessions/get?targetUserId=' + u.user_id).then(function(r){if(r.data && r.data.id){setSess(r.data);}}).catch(function(){});
    if(socket){
      socket.emit('create_session',{targetUserId:u.user_id});
      var onS=function(s){setSess(s);socket.off('session_created',onS);};
      socket.on('session_created',onS);
    }
  };

  const respond = async (requestId, action) => {
    try { await api.post('/friends/respond', { requestId, accept: action === 'accept' }); setMsg(action === 'accept' ? '✅ 已接受' : '已拒绝'); const r = await api.get('/friends'); setFriends(r.data); const r2 = await api.get('/friends/requests'); setRequests(r2.data); } catch(e) {}
    setTimeout(() => setMsg(''), 3000);
  };

  return (
    <div className="page-content">
      <div className="discovery-header">
        <h2>👥 好友</h2>
        <p className="subtitle">{friends.length} 位好友</p>
      </div>

      {msg && <div style={{padding:10,margin:'0 auto 16px',maxWidth:600,textAlign:'center',borderRadius:8,background:msg.includes('✅')?'rgba(74,222,128,0.1)':'rgba(255,107,107,0.1)',color:msg.includes('✅')?'#4ade80':'#ff6b6b'}}>{msg}</div>}

      <div className="discovery-filters">
        <button className={`filter-btn ${tab==='friends'?'active':''}`} onClick={()=>setTab('friends')}>👥 好友 ({friends.length})</button>
        <button className={`filter-btn ${tab==='requests'?'active':''}`} onClick={()=>setTab('requests')}>📩 请求 {requests.length > 0 && `(${requests.length})`}</button>
        <button className={`filter-btn ${tab==='nearby'?'active':''}`} onClick={()=>setTab('nearby')}>📍 附近 ({nearby.length})</button>
      </div>

      {/* 好友请求 */}
      {tab === 'requests' && requests.length > 0 && (
        <div className="users-grid" style={{marginBottom:20}}>
          {requests.map(r => (
            <div key={r.from_user_id} className="user-card">
              <div className="user-card-header">
                <div className="avatar">{r.display_name?.charAt(0) || '?'}</div>
                <div>
                  <div className="user-name">{r.display_name || r.username}</div>
                  <div className="user-country">{FLAGS[r.country_code]||''} {r.country_code}</div>
                </div>
              </div>
              {r.message && <p className="user-bio">{r.message}</p>}
              <div className="btn-group" style={{marginTop:8}}>
                <button className="btn btn-primary" style={{flex:1}} onClick={() => respond(r.id, 'accept')}>✅ 接受</button>
                <button className="btn btn-secondary" style={{flex:1}} onClick={() => respond(r.id, 'reject')}>❌ 拒绝</button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* 附近的人 */}
      {tab === 'nearby' && (
        <div className="users-grid">
          {nearby.length === 0 ? (
            <div style={{gridColumn:'1/-1',textAlign:'center',padding:60,color:'var(--text-dim)'}}>
              <p>📍 附近暂无其他用户</p>
              <p style={{fontSize:'0.8rem',marginTop:4}}>同国家/地区的用户会显示在这里</p>
            </div>
          ) : nearby.map(u => (
            <div key={u.id} className="user-card">
              <div className="user-card-header" onClick={() => nav('/profile/'+u.id)} style={{cursor:'pointer'}}>
                <div className="avatar">{u.display_name?.charAt(0) || '?'}</div>
                <div>
                  <div className="user-name">{u.display_name || u.username}</div>
                  <div className="user-country">{FLAGS[u.country_code]||''} {u.country_code}</div>
                  {u.commonCount > 0 && <div className="user-country" style={{color:'var(--accent2)'}}>🎯 {u.commonCount}个共同兴趣</div>}
                </div>
              </div>
              {u.bio && <p className="user-bio">{u.bio}</p>}
              <div style={{display:'flex',gap:4,flexWrap:'wrap',marginTop:6}}>
                {(u.interests||[]).slice(0,3).map(i => <span key={i} className="meta-badge" style={u.commonInterests?.includes(i)?{background:'rgba(74,222,128,0.15)',color:'#4ade80'}:{}}>{i}</span>)}
              </div>
              <button className="btn btn-primary" style={{width:'100%',marginTop:8}} onClick={() => sendRequest(u.id)}>➕ 加好友</button>
            </div>
          ))}
        </div>
      )}

      {/* 好友列表 */}
      {tab === 'friends' && (
        <div className="users-grid">
          {friends.map(f => (
            <div key={f.user_id} className="user-card" style={{position:"relative"}}>
              <div className="user-card-header" onClick={() => nav('/profile/'+f.user_id)} style={{cursor:'pointer'}}>
                <div className="avatar">{f.display_name?.charAt(0) || '?'}</div>
                <div>
                  <div className="user-name">{f.display_name || f.username}</div>
                  <div className="user-country">{FLAGS[f.country_code]||''} {f.country_code}</div>
                </div>
              </div>
              <p className="user-bio">{f.bio || '这个人很懒~'}</p>
              {unread[f.user_id] > 0 && <div style={{position:"absolute",top:-4,right:-4,background:"#ef4444",color:"#fff",width:22,height:22,borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"0.72rem",fontWeight:700,boxShadow:"0 2px 6px rgba(239,68,68,.5)"}}>{unread[f.user_id]}</div>}
              <div style={{display:'flex',gap:6,marginTop:8}}>
                <button className="btn btn-primary" style={{flex:1,padding:'8px 12px',fontSize:'0.82rem'}} onClick={function(e){e.stopPropagation();handleChat(f)}}>CHAT</button>
                <button className="btn btn-secondary" style={{flex:0,padding:'8px 12px',fontSize:'0.82rem',background:'#ef4444',color:'#fff',border:'none'}} onClick={function(e){e.stopPropagation();if(window.confirm('DEL'))removeFriend(f.user_id)}}>DEL</button>
              </div>
            </div>
          ))}
          {friends.length === 0 && (
            <div style={{gridColumn:'1/-1',textAlign:'center',padding:60,color:'var(--text-dim)'}}>
              <p>还没有好友</p>
              <button className="btn btn-primary" style={{marginTop:12}} onClick={() => nav('/discover')}>🌐 去探索</button>
            </div>
          )}
        </div>
      )}
      {incomingMsg && (
        <div style={{
          position:"fixed", top:76, left:"50%", transform:"translateX(-50%)",
          zIndex:9999, background:"var(--accent)", color:"#fff",
          padding:"10px 20px", borderRadius:12, cursor:"pointer",
          boxShadow:"0 4px 20px rgba(0,0,0,.25)", maxWidth:360, width:"90%",
          display:"flex", alignItems:"center", gap:10
        }} onClick={function(){handleIncoming(incomingMsg)}}>
          <div style={{width:36,height:36,borderRadius:"50%",background:"rgba(255,255,255,.2)",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:700,fontSize:"1rem"}}>
            {incomingMsg.user?.display_name?.charAt(0)?.toUpperCase() || "?"}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:"0.85rem",fontWeight:600}}>{incomingMsg.user?.display_name || incomingMsg.user?.username}</div>
            <div style={{fontSize:"0.78rem",opacity:.85,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{incomingMsg.text}</div>
          </div>
          <span style={{fontSize:"1.2rem",opacity:.7}}>-></span>
        </div>
      )}
      {showChat && partner && (
        <ChatBox
          session={sess}
          partner={partner}
          onClose={function(){setShowChat(false);setPartner(null);setSess({id:null})}}
        />
      )}
    </div>
  );
}
